import {useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import styles from './Subscriptions.module.css'
import useCurrentUser from '../../../hooks/useCurrentUser'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import {usePurchaseItemForms} from '../hooks'
import {
	purchaseSubscription,
	deleteSubscription,
	updateSubscription,
	setActiveComponent,
	setEditor
} from './availableSubscriptionsSlice'
import {
	setShowUpdateModal as setShowUpdateBillingModal,
	setShowResetCurrencyModal,
	setAllowCurrencyUpdate
} from '../Billing/slice'
import {Link} from 'react-router-dom'
import PriceOption from './PriceOption'
import DiscussResourceButton from '../../DiscussResourceButton/DiscussResourceButton'
import {envAwarePost} from '../../../util/util'

import {setMultiFormsModal} from '../../../state/customFormsSlice'

const Subscription = ({subscription})=>{
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const user = useCurrentUser()
	const {
		status:subscriptionFormsStatus,
		forms:subscriptionForms
	} = usePurchaseItemForms('subscription',subscription.subscription_id)

	const isClient = user?.account_type === 'client'
	//currently only client account have payment methods
	//attached
	const hasPaymentMethod = isClient && user.billing_data.payment_method_exists
	const [status,setStatus] = useState('idle')

	const forwardToForms = (forms) => {
		//assign the forms to the client then forward to 
		//the modal for them to fill out the newly assigned forms
		envAwarePost('api/customForms/',{
			action:'addFormsToClient',
			form_ids:forms.map(form=>form.id),
		}).then(()=>{
			dispatch(setMultiFormsModal({
				show:true,
				programs:[],
				forms
			}))
		})
	}

	const handleSubscribe = ()=>{
		if(!window.confirm('Are you sure? You can cancel at any time.')) return
		setStatus('pending')
		const subscription_id = subscription.subscription_id
		const price_id = subscription.price.id
		const payload = {id:subscription_id,price_id}
		statusDispatch(
			purchaseSubscription(payload),
			'new subscription',
			'create'
		).then(({payload})=>{
			setStatus('idle')
			if (payload.success === '1') {
				if(subscriptionForms.length>0) forwardToForms(subscriptionForms)
			} else if(payload?.errors?.is_mixed_currency_error) {
				const allowUpdate = payload?.data?.num_active_subscriptions === 0
				//check if the error was a result of mixed currencies on the stripe
				//connect account customer
				dispatch(setShowResetCurrencyModal(true))
				dispatch(setAllowCurrencyUpdate(allowUpdate))
			}
		})
	}

	const handleSetupBilling = ()=>{
		dispatch(setShowUpdateBillingModal(true))
	}

	const handleToggleActive = e => {
		dispatch(
			updateSubscription({
				is_active:e.target.checked?1:0,
				id:subscription.id,
			}),
			'subscription',
			'edit'
		)
	}
	const handleDelete = ()=>{
		if(!window.confirm('Are you sure?')) return 
		statusDispatch(deleteSubscription({id:subscription.id}),'subscription','delete')
	}
	return (
		<div className="p-3 rounded border bg-white d-flex flex-column justify-content-between">
			<div>
				<div className="d-flex justify-content-between align-items-start">
					<div className="d-flex align-items-start">
						{Boolean(subscription.image)&&
							<img 
								src={subscription.image} 
								style={{
									width:'100px',
									height:'100px',
									objectFit:'cover',
									border:'1px solid #ccc',
									borderRadius:'7px',
									overflow:'hidden',
									marginRight:'4px'
								}}
							/>
						}
						<span style={{fontWeight:'600'}}>
							{subscription.name}
						</span>
					</div>
					{!isClient&&
						<label 
							className="d-flex align-items-center" 
							style={{fontSize:'14px'}}
						>
							Enabled: 
							<div style={{position:'relative'}}>
								<Form.Switch 
									defaultChecked={subscription.is_active === 1}
									id={`is-active-${subscription.id}`} 
									onChange={handleToggleActive}
									className="ml-1"
								/>
								<div style={{
									userSelect:'none',
									position:'absolute',
									top:0,
									left:'50%',
									transform:'translate(-50%,-64%)',
									fontSize:'9px',
									color:subscription.is_active === 1?'green':'grey'
								}}>
									{subscription.is_active === 1?'on':'off'}
								</div>
							</div>
						</label>
					}
				</div>
				<div>{subscription.notes}</div>
				<hr className="my-1"/>
				{Boolean(subscription.price)&&
					<>
						<div className="d-flex align-items-center">
							<div class="text-primary mr-2">
								Pricing:
							</div>
							<PriceOption price={subscription.price} />
						</div>
					</>
				}
				{subscription.session_credits>0&&
					<div>
						<span className="text-primary mr-2">
							Session credits:
						</span> 
						{subscription.session_credits} per pay cycle
					</div>
				}
				<div>
					<span className="text-primary mr-2">
						Forms & Waivers:
					</span> 
					{
						subscriptionFormsStatus === 'pending'
						? 'loading forms...'
						: (
							subscriptionForms.length === 0
							? 'No forms or waivers for this subscription'
							: subscriptionForms.map(f=>f.form_title).join(', ')
						)
					}
				</div>
			</div>
			<div className="text-right">
				{
					isClient?
					(
						hasPaymentMethod ?
						<>
							<OverlayTrigger overlay={
								<Tooltip>Discuss this subscription in the chat</Tooltip>
							}>
								<span className="ml-auto">
									<DiscussResourceButton
										className="btn btn-sm btn-link text-info"
										name={subscription.name}
										id={subscription.subscription_id}
										type="subscription"
									>
										<span>Discuss</span>
									</DiscussResourceButton>
								</span>
							</OverlayTrigger>
							<Button 
								disabled={status==='pending'}
								onClick={handleSubscribe}
								variant="link" 
								size="sm"
							>
								{
									status==='pending'?
									<span>
										<span className="mr-1">Subscribing</span>
										<Spinner animation="border" size="sm"/>
									</span>
									:
									"Subscribe"
								}
							</Button>
						</>
						:
						<>
							<Button 
								onClick={handleSetupBilling}
								variant="link" 
								size="sm"
							>
								Subscribe
							</Button>
						</>
					)
					:
					<>
						{subscription.is_active === 1&&
							<OverlayTrigger overlay={
								<Tooltip>Discuss this subscription in the chat</Tooltip>
							}>
								<span className="ml-auto">
									<DiscussResourceButton
										className="btn btn-sm btn-link text-info"
										name={subscription.name}
										id={subscription.subscription_id}
										type="subscription"
									>
										Discuss
									</DiscussResourceButton>
								</span>
							</OverlayTrigger>
						}
						<Button 
							className="text-danger" 
							onClick={handleDelete}
							variant="link" 
							size="sm"
						>
							Delete
						</Button>
						<Button 
							onClick={()=>{
								dispatch(setEditor({
									id:subscription.subscription_id
								}))
								dispatch(setActiveComponent('editor'))
							}}
							variant="link" 
							size="sm"
						>
							Edit
						</Button>
					</>
				}
			</div>
		</div>
	)
}

export default Subscription